import { withDisplayName } from '@hocs/with-display-name'
import Media from '@ui/media/media'
import { graphql } from 'gatsby'
import React from 'react'

const ContentfulEmbeddedAsset: Utils.EntryFC<
  Queries.ContentfulEmbeddedAssetFragment
> = ({ content: { title, url } }) => <Media title={title} url={url} />

export const query = graphql`
  fragment ContentfulEmbeddedAsset on ContentfulEmbeddedAsset {
    ...ContentfulEntry
    title
    url
  }
`
export default withDisplayName(
  ContentfulEmbeddedAsset,
  'ContentfulEmbeddedAsset'
)
